import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { audioVideoReceiptReducer, IAudioVideoReceiptState } from './receipt';

const audioVideoPersistConfig = {
  key: 'audioVideo',
  timeout: 60 * 60,
  storage,
  whitelist: ['receipt']
}

export interface IAudioVideoState {
  receipt: IAudioVideoReceiptState
}

export const audioVideoReducer = persistReducer(
  audioVideoPersistConfig,
  combineReducers<IAudioVideoState>({
    receipt: audioVideoReceiptReducer
  })
) as any; // Casting resolves a typescript complaint that doesn't make sense...
